var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-tags"},_vm._l((_vm.labels),function(item){return _c('div',{staticClass:"tag"},[_c('span',{class:item.class},[_vm._v(_vm._s(item.count)+" ")]),_c('span',[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }